import { clickTravelThreshold as defaultClickTravelThreshold } from "../config";
export function getElementSize(el) {
  const rect = el.getBoundingClientRect();
  return [rect.right - rect.left, rect.bottom - rect.top];
}

export function getRelativeCoords(e, el) {
  const rect = el.getBoundingClientRect();
  return [e.clientX - rect.left, e.clientY - rect.top];
}

export function dragClickListener(
  e,
  {
    onDrag,
    onClick,
    onDragRelease,
    clickTravelThreshold = defaultClickTravelThreshold,
    onPointerDown,
  }
) {
  // Handle  only left-click e
  if (e.button !== 0) {
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  if (typeof onPointerDown === "function") {
    onPointerDown(e);
  }
  // remember and enclose the initial parameters
  const startX = e.clientX;
  const startY = e.clientY;
  let cumulativePointerTravelDistance = 0;
  let isClick = true;
  const pointerMoveListener = (e) => {
    const dx = e.clientX - startX;
    const dy = e.clientY - startY;
    cumulativePointerTravelDistance += dx ** 2 + dy ** 2;
    // is it still a click?
    if (cumulativePointerTravelDistance > clickTravelThreshold ** 2) {
      isClick = false;
    }
    if (isClick) {
      return;
    }
    // it's a drag, process it
    onDrag(e, { dx, dy });
  };

  const pointerUpListener = (e) => {
    if (isClick && typeof onClick === "function") {
      onClick(e);
    } else if (typeof onDragRelease === "function") {
      onDragRelease();
    }
    document.removeEventListener("pointermove", pointerMoveListener);
    document.removeEventListener("pointerup", pointerUpListener);
  };

  document.addEventListener("pointermove", pointerMoveListener);
  document.addEventListener("pointerup", pointerUpListener);
}

/** Get the width parameter to request from the server based on viewport size
 * If we are lucky it will be the same size as requested by SMV and we will
 * save on network requests.
 * TODO: MAYBE request the same size as SMV would (taking into the account the side panel)
 *  at the expense of having a chance to get undersampled images in configureLocations step
 */

export function getDesiredImageWidth(naturalAspect = 1) {
  const viewportWidthPx = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );
  const viewportHeightPx = Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0
  );
  const availableHeight = viewportHeightPx;
  const availableWidth = viewportWidthPx;
  const heightLimitedWidth = availableHeight / naturalAspect;
  const width = Math.min(heightLimitedWidth, availableWidth);
  const requestedWidth = Math.ceil(width / 100) * 100;
  return requestedWidth;
}

export function clearCanvasByContext(ctx) {
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
}
